import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCwtq1-ZaLWcRiM2W7OQR_-y8ZKcHBT6oQ",
  authDomain: "ambulancias-medik-2000.firebaseapp.com",
  projectId: "ambulancias-medik-2000",
  storageBucket: "ambulancias-medik-2000.firebasestorage.app",
  messagingSenderId: "931486273714",
  appId: "1:931486273714:web:fcdfe24e18eb321e06b9ab",
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

const VAPID_KEY =
  "BB-pMaOANLna7Y8rZuuA7y9em1QY_QIYDcbc7Os9HpglCkLZCwRhqBIyZJ8p5YIvse60n17Hv2cg3o5cozhS9yc";

/**
 * Registrar el Service Worker, pedir permiso y devolver el token.
 */
export async function requestNotificationPermission() {
  // Registrar el Service Worker
  try {
    await navigator.serviceWorker.register("/firebase-messaging-sw.js");
  } catch (swErr) {
    console.error("❌ Error registrando SW:", swErr);
    throw swErr;
  }

  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error("Permiso de notificaciones denegado.");
  }

  // Obtener token FCM
  try {
    const token = await getToken(messaging, { vapidKey: VAPID_KEY });
    // console.info("► Token FCM generado:", token);
    return token;
  } catch (tokErr) {
    console.error("❌ Error obteniendo token FCM:", tokErr);
    throw tokErr;
  }
}

/**
 * Helper para escuchar mensajes en primer plano.
 * Devolver una Promise que se resuelve con el payload.
 */
export function onMessageListener() {
  return new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
}

// ||| Dejar solo para pruebas
// window.requestNotificationPermission = requestNotificationPermission;
// window.onMessageListener = onMessageListener;
